import React, { useState, useEffect } from "react"
import { Link, graphql } from "gatsby"
import SEO from "../../../components/seo"
import Layout from "../../../app/layout"

import { Row, Col, Breadcrumb } from "antd"

import Container from "../../../components/Container"
import { ChevronRight } from "../../../components/Icon"
import Newsletter from "../../../components/Newsletter"
import BlogMasthead from "../../../components/BlogMasthead"
import ScrollAnimation from "react-animate-on-scroll"
import PageNotFound from "../../404"
import { useI18next } from "gatsby-plugin-react-i18next"

const SinglePage = ({
  pageContext: { data: dataAll = {}, language = "id" },
}) => {
  const { t } = useI18next()
  const [backto, setBackto] = useState("")
  const data = dataAll[language]
  useEffect(() => {
    setBackto((window.location.search || "").replace("?cat=", ""))
  }, [])
  if (!data) return <PageNotFound />
  return (
    <Layout>
      <SEO title={data.title} />
      <Container>
        <Breadcrumb separator={<ChevronRight />}>
          <Breadcrumb.Item>
            <Link to="/">{t("Beranda")}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={backto || "/informasi/berita/"}>{t('Berita')}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{data.title}</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      <BlogMasthead
        title={data.title}
        image={data.image}
        category={data.news_category}
        date={data.created_at}
        author={data.writer_name}
        photographer={data.photographer_name}
      />
      <Container>
        <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
          <article className="article section text-medium">
            <Row gutter={40} justify="space-between">
              <Col span={24} md={12}>
                <div dangerouslySetInnerHTML={{ __html: data.content }} />
              </Col>

              <Col span={24} md={8}>
                <div offsetTop={80} className="sticky-sidebar disable-mobile">
                  <Newsletter />
                </div>
              </Col>
            </Row>
          </article>
        </ScrollAnimation>
      </Container>
    </Layout>
  )
}

export default SinglePage

export const query = graphql`
  query NewsSingleQuery($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
